var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCoin = function SvgCoin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 11.2604C8.53117 11.2604 7.1225 10.9422 6.08389 10.3756C5.04528 9.80912 4.46179 9.04076 4.46179 8.23958C4.46179 7.43841 5.04528 6.67005 6.08389 6.10353C7.1225 5.53702 8.53117 5.21875 9.99999 5.21875C11.4688 5.21875 12.8775 5.53702 13.9161 6.10353C14.9547 6.67005 15.5382 7.43841 15.5382 8.23958C15.5382 9.04076 14.9547 9.80912 13.9161 10.3756C12.8775 10.9422 11.4688 11.2604 9.99999 11.2604ZM9.99999 11.2604V14.533M15.5382 8.2756V12.0156C15.5382 13.1279 13.0586 14.533 9.99999 14.533M9.99999 14.533C6.94133 14.533 4.46179 13.1279 4.46179 12.0156V8.2756M6.72742 10.6751V13.9644M13.2726 10.6759V13.9682",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fillOpacity: 0
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "coin.1147b15bc0793497702ea2a78e494406.svg";